module.exports = __webpack_public_path__ + "static/media/1.6c453a89.jpg";